import { makeAutoObservable } from "mobx";
import { P24_CHANNEL_ID, P24_CHANNEL_TAG, } from "../ordering";
import { PPaymentMediumGenerator } from "./PPaymentMedium";
export class PRestaurant {
    constructor(params) {
        this.domain = params.domain;
        this.productTypes = params.productTypes;
        this.modifierTypes = params.modifierTypes;
        this.customParameterTypes = params.customParameterTypes;
        this.packagingFeeTypes = params.packagingFeeTypes;
        this.name = params.name;
        this.slug = params.slug;
        this.menu = params.menu;
        this.address = params.address; // TODO: unify PRestaurantAddress with this model and use the only one?
        this.promotionTypes = params.promotionTypes;
        this.isApplePaySupported = params.isApplePaySupported;
        this.franchiseName = params.franchiseName;
        this.orderPhoneNumbers = params.orderPhoneNumbers;
        this.contactPhoneNumbers = params.contactPhoneNumbers;
        this.contactEmail = params.contactEmail;
        this.logoUrl = params.logoUrl;
        makeAutoObservable(this);
    }
    get id() {
        return this.domain.id;
    }
    get enableFod() {
        return this.domain.orderingPolicy.enableFod;
    }
    get cashRequiresExactAmount() {
        return this.domain.orderingPolicy.cashRequiresExactAmount;
    }
    get enableMarketingConsents() {
        return this.domain.orderingPolicy.enableMarketingConsents;
    }
    get blikLevel0Enabled() {
        return this.domain.paymentChannels.some((channel) => channel.id.tag === P24_CHANNEL_TAG &&
            channel.id.contents === P24_CHANNEL_ID.BLIK_LEVEL_0);
    }
    get paymentMediums() {
        const { paymentChannels, paymentMethods } = this.domain;
        return PPaymentMediumGenerator.group({
            paymentChannels,
            paymentMethods,
            includeApplePay: this.isApplePaySupported,
        });
    }
    get maxOrderValue() {
        return this.domain.orderingPolicy.maxOrderValue;
    }
    get fulfillmentMethods() {
        return this.domain.fulfillmentMethods;
    }
}
